export default __webpack_public_path__ + "static/media/water-lower.823684c1.png";